module.exports = __webpack_public_path__ + "static/media/tag_living_visual.2952bcb5.svg";